// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__tQGOn","sliderWrapper":"Slider_sliderWrapper__mfz7M"};